export const listPlacement = {
  bottom_start: {
    placement: 'bottom-start',
  },
  bottom_end: {
    placement: 'bottom-end',
  },
  bottom: {
    placement: 'bottom',
  },
  top_start: {
    placement: 'top-start',
  },
  top_end: {
    placement: 'top-end',
  },
  top: {
    placement: 'top',
  },
  left_start: {
    placement: 'left-start',
  },
  left_end: {
    placement: 'left-end',
  },
  left: {
    placement: 'left',
  },
  right_start: {
    placement: 'right-start',
  },
  right_end: {
    placement: 'right-end',
  },
  right: {
    placement: 'right',
  },
};

export const zIndex = {
  searchCard: 8,
  detailModal: 12,
}